import { render, staticRenderFns } from "./SurveyOwner.vue?vue&type=template&id=7a21e1a3&scoped=true&"
import script from "./SurveyOwner.vue?vue&type=script&lang=js&"
export * from "./SurveyOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21e1a3",
  null
  
)

export default component.exports